// extracted by mini-css-extract-plugin
module.exports = {"container":"news-carousel_container__XaKO6","image":"news-carousel_image__jmkcA","each-slide":"news-carousel_each-slide__1qVLB"};